import { useSettingsContext } from "@/components/Settings/hooks/useSettingsContext"

const useContractation = () => {
  const Settings = useSettingsContext();  

  const activeContractations = {
    num: (
      Settings.contractation?.electricity?.enabled ? 1 : 0
    ) + (
      Settings.contractation?.gas?.enabled ? 1 : 0
    ) + (
      Settings.contractation?.dual?.enabled ? 1 : 0
    ),
    types: {
      electricity: Settings.contractation?.electricity?.enabled,
      gas: Settings.contractation?.gas?.enabled,
      dual: Settings.contractation?.dual?.enabled,
    },
    untranslatedURLs: {
      electricity: "common:url.electricityContractation",
      gas: "common:url.gasContractation",
      dual: "common:url.dualContractation"
    }
  };

  const isContractationPath = (path: string) => {
    return Object.values(activeContractations.untranslatedURLs).includes(path);
  }

  return {
    activeContractations,
    isContractationPath
  }
}

export default useContractation;